import { AxiosRequestConfig } from 'axios';
import axios from './axios';
import { IResponse } from './types';

// HTTP 只处理 status是200的响应，res是response data
class HTTP {
  config: AxiosRequestConfig = {
    baseURL: axios.defaults.baseURL
  };
  private handlerError() {
    try {
    } catch (e) {
      console.log(e);
    }
  }
  private getConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
    return Object.assign({}, this.config, config || {});
  }
  protected async queryGet(
    url: string,
    query: any = {},
    config?: AxiosRequestConfig
  ) {
    let _char = url.includes('?') ? '&' : '?';
    let _url = url + _char + objToUrl(query);
    const res: IResponse<any> = await axios.get(_url, this.getConfig(config));
    return res;
  }
  protected async get(url: string, data?: any, config?: AxiosRequestConfig) {
    const res: IResponse<any> = await axios.request({
      ...this.getConfig(config),
      method: 'GET',
      url: url,
      params: data
    });
    return res;
  }

  protected async post(url: string, data?: any, config?: AxiosRequestConfig) {
    const res: IResponse<any> = await axios.post(
      url,
      data,
      this.getConfig(config)
    );
    return res;
  }
  protected async delete(url: string, config?: AxiosRequestConfig) {
    const res: IResponse<any> = await axios.delete(url, this.getConfig(config));
    return res;
  }
  protected async put(url: string, data?: any, config?: AxiosRequestConfig) {
    const res: IResponse<any> = await axios.put(
      url,
      data,
      this.getConfig(config)
    );
    return res;
  }
  protected async patch(url: string, data?: any, config?: AxiosRequestConfig) {
    const res = await axios.patch(url, data, config);
    return res;
  }
  protected async request(config: AxiosRequestConfig) {
    const res = await axios.request(config);
    return res;
  }
  protected async head(url: string, config?: AxiosRequestConfig) {
    const res = await axios.head(url, config);
    return res;
  }
  protected async options(url: string, config?: AxiosRequestConfig) {
    const res = await axios.options(url, config);
    return res;
  }
}
const objToUrl = (obj: any) => {
  let arr = [];
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
    }
  }
  return arr.join('&');
};
export default HTTP;
